import { render, staticRenderFns } from "./group-leader.vue?vue&type=template&id=bac403d0&"
import script from "./group-leader.vue?vue&type=script&lang=js&"
export * from "./group-leader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\liweicheng\\web-m\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bac403d0')) {
      api.createRecord('bac403d0', component.options)
    } else {
      api.reload('bac403d0', component.options)
    }
    module.hot.accept("./group-leader.vue?vue&type=template&id=bac403d0&", function () {
      api.rerender('bac403d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/picker/group-leader.vue"
export default component.exports